import useGlobalBatchPreparationFinishedMessage from '@/hooks/useGlobalBatchPreparationFinishedMessage';
import useGlobalBookYearClosingFinishedMessage from '@/hooks/useGlobalBookYearClosingFinishedMessage';
import useGlobalDebtorsBatchDoneMessage from '@/hooks/useGlobalDebtorsDoneMessage';
import useGlobalImportFinishedMessages from '@/hooks/useGlobalImportFinishedMessages';
import useGlobalManualOctopusSyncMessages from '@/hooks/useGlobalManualOctopusSyncMessages';
import useGlobalManualProcessingOfAdditionalPerformancesMessages from '@/hooks/useGlobalManualProcessingOfAdditionalPerformancesMessages';
import useGlobalMeetingVotingBallotGenerationMessages from '@/hooks/useGlobalMeetingVotingBallotGenerationMessages';

const GlobalMessages = () => {
  useGlobalBatchPreparationFinishedMessage();
  useGlobalBookYearClosingFinishedMessage();
  useGlobalDebtorsBatchDoneMessage();
  useGlobalImportFinishedMessages();
  useGlobalManualOctopusSyncMessages();
  useGlobalManualProcessingOfAdditionalPerformancesMessages();
  useGlobalMeetingVotingBallotGenerationMessages();

  return null;
};

export default GlobalMessages;
